import type { SpacingOptions } from '@mui/system'

export const spacing: Record<'spacing', SpacingOptions> = {
  spacing: (factor: number) => `${4 * factor}px`,
}
